import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { useCan } from "components/Can";
import "components/ConnectInterventionModal/ConnectInterventionModal.scss";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useAppendPinMutation } from "modules/AppointmentDetails/components/Interventions/hooks";
import { useConnectInterventionMutation } from "modules/AppointmentDetails/hooks";

import type { ConnectToInterventionPayload } from "components/ConnectInterventionModal";
import type { Intervention } from "models";

type ConnectInterventionButtonProps = {
  checklistName: string;
  intervention: Intervention;
  payload: ConnectToInterventionPayload;
  onCloseConnectModal: () => void;
};

export const ConnectInterventionButton = ({ payload, intervention, checklistName, onCloseConnectModal }: ConnectInterventionButtonProps) => {
  const { t } = useTranslation();

  const { mutateAsync: connectIntervention } = useConnectInterventionMutation();
  const { mutateAsync: appendPin } = useAppendPinMutation();

  const canCreateFullPin = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.PinFull);

  const handleConnection = async () => {
    await connectIntervention({ intervention_id: intervention.id, question_result_id: payload.question_result_id });
    onCloseConnectModal();

    if (!intervention.pin_history?.length || !canCreateFullPin) return;

    await appendPin({
      ...intervention.pin_history[0],
      intervention_id: intervention.id,
      note: t("v8_intervention_connected_message", "Intervention connected to {{title}} from {{checklist_name}}")
        .replace("{{title}}", payload.title)
        .replace("{{checklist_name}}", checklistName)
    });
  };

  return (
    <Button basic className="ConnectInterventionModal__linkButton" onClick={handleConnection}>
      <Icon className="link horizontal grey" />
    </Button>
  );
};
